import React from "react";
import { LOGOS } from "@/data/content";

/**
 * Official Quentin Young compass mark.
 * Uses the provided PNG asset directly (per brand spec: do not reinterpret the logo).
 * Defaults to a subtle, environmental treatment with adjustable opacity and size.
 */
export const CompassMark = ({
  size = 40,
  opacity = 1,
  className = "",
  alt = "Quentin Young compass mark",
  loading = "lazy",
}) => {
  return (
    <img
      src={LOGOS.compass}
      alt={alt}
      width={size}
      height={size}
      loading={loading}
      style={{ width: size, height: size, opacity, objectFit: "contain" }}
      className={`select-none pointer-events-none ${className}`}
      draggable={false}
    />
  );
};

/**
 * Wordmark, rendered typographically in the brand serif (Cormorant Garamond).
 * Pairs naturally with the compass mark in the header.
 */
export const Wordmark = ({ className = "", height = 28, alt = "Quentin Young" }) => {
  // height drives equivalent font sizing
  const fontSize = Math.round(height * 0.78);
  return (
    <span
      role="img"
      aria-label={alt}
      className={`font-serif tracking-[0.18em] uppercase text-paper-primary select-none ${className}`}
      style={{ fontSize, lineHeight: 1, letterSpacing: "0.16em", fontWeight: 400 }}
    >
      Quentin&nbsp;Young
    </span>
  );
};

/**
 * Medallion, used for hero / artifact moments, never as a watermark.
 */
export const Medallion = ({ size = 320, className = "", alt = "Quentin Young medallion: What you say you are is what survives reality." }) => {
  return (
    <img
      src={LOGOS.medallion}
      alt={alt}
      style={{ width: size, height: size, objectFit: "contain" }}
      className={`select-none ${className}`}
      draggable={false}
    />
  );
};

export default CompassMark;
